import React from 'react';
import { Box } from '@/common/components/layout/Box';
import BulbIcon from '@/icons/BulbIcon';
import DeleteIcon from '@/icons/DeleteIcon';
import WarningIcon from '@/icons/WarningIcon';
import { Color } from '@/common/Color';
import clsx from 'clsx';
import './Paper.less';
import PropTypes from 'prop-types';

export const InfoPaper = ({ children, className, closeAction, color }) => (
    <CloseablePaperWithIcon
        className={className}
        color={color}
        icon={<BulbIcon height={20} width={19} fill="#000" />}
        closeAction={closeAction}
    >
        {children}
    </CloseablePaperWithIcon>
);

export const WarningPaper = ({ children, className, closeAction, color }) => (
    <CloseablePaperWithIcon
        className={className}
        color={color || Color.softRed}
        icon={<WarningIcon width={20} height={19} fill="#FF224D" />}
        closeAction={closeAction}
    >
        {children}
    </CloseablePaperWithIcon>
);

export const CloseablePaperWithIcon = ({ children, className, closeAction, icon, color }) => (
    <Paper className={className} color={color}>
        <Box padding={10} spacing={10} horizontal justifyContent="space-between">
            <div>{icon}</div>
            <div className="content">{children}</div>
            {closeAction ? (
                <div className="close" onClick={closeAction}>
                    <DeleteIcon fill="#808080" opacity={0.5} height={14} width={14} />
                </div>
            ) : null}
        </Box>
    </Paper>
);

export const Paper = ({ children, className, color }) => (
    <Box className={clsx(`paper ${className}`)} bgColor={color}>
        {children}
    </Box>
);

Paper.propTypes = {
    color: PropTypes.oneOf([Color.paleGray, Color.softRed])
};
